import { render } from "./ViewMoreUsers.vue?vue&type=template&id=8b0a5202&scoped=true&ts=true&lang=pug"
import script from "./ViewMoreUsers.vue?vue&type=script&lang=ts"
export * from "./ViewMoreUsers.vue?vue&type=script&lang=ts"

import "./ViewMoreUsers.vue?vue&type=style&index=0&id=8b0a5202&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0a5202"]])

export default __exports__